import { METHOD } from 'services/method'

export const API_CUSTOMER = {
    LIST: {
        api: '/v1/dashboard-admin/analytic/customer/list',
        method: METHOD.POST,
    },
    CITIES: {
        api: '/v1/dashboard-admin/analytic/customer/list-cities',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/analytic/customer/list/export',
        method: METHOD.POST,
    },
}
